enum Injectables {
  SOCKET_CLIENT = 'SOCKET_CLIENT',
  SUBSCRIPTION_CONTEXT = 'SUBSCRIPTION_CONTEXT',
  LOCAL_DB = 'LOCAL_DB',
  REPOSITORY = 'REPOSITORY',
  ENVIRONMENT_UTIL = 'ENVIRONMENT_UTIL',
  INTERVAL_MANAGER = 'INTERVAL_MANAGER',
}

export default Injectables;
